import * as Loadable from 'react-loadable'

import {
  fetchHomePageDataBySite,
  onBeforeHomePageView
} from '../../../common/actions/homePage'
import { IPageComponent } from '../../../typings/pageComponent'
import LoadingCover from '../../components/loadingCover'

const HomePageLoadableContainer = (Loadable as any)({
  loader: () =>
    import(/* webpackChunkName: "homePage" */ './homePageContainer'),
  loading: LoadingCover,
  webpack: () => [require.resolveWeak('./homePageContainer')],
  modules: ['./homePageContainer']
}) as IPageComponent<any>

HomePageLoadableContainer.loadData = ({ store, location, apiAppUrlPrefix }) =>
  store.dispatch(fetchHomePageDataBySite({ location, apiAppUrlPrefix }))

HomePageLoadableContainer.onBeforePageView = ({ store }) =>
  store.dispatch(onBeforeHomePageView())

export default HomePageLoadableContainer
